import { ICell } from 'modules/Kino/models/cell';

export const cell: ICell = {
  id: null,
  number: 0,
  selected: false,
  winner: false,
};
